/* eslint-disable @typescript-eslint/no-unused-vars */
import clsx from "clsx";
import { FC, Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import Select, { components } from "react-select";
import * as action from "../../../actions/playground";
import Button from "../../../styles/components/Button";
import "../../../styles/css/requestnotification.css";
import "../../../styles/css/select.css";

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const DeviceTest: FC = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 900px)" });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });
  return (
    <>
      <h3>Device Test!</h3>
      {isDesktopOrLaptop && <p>You are a desktop or laptop</p>}
      {isBigScreen && <p>You have a huge screen</p>}
      {isTabletOrMobile && <p>You are a tablet or mobile phone</p>}
      {/* <p>Your are in {isPortrait ? "portrait" : "landscape"} orientation</p> */}
      {/* {isRetina && <p>You are retina</p>} */}
    </>
  );
};

const SetupCampaignTab: FC = () => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [deletedIds, setDeletedIds] = useState<JSX.Element[]>([]);
  const [result, setResult] = useState<JSX.Element>();
  const [input, setInput] = useState<any>();
  const [dataYT, setDataYT] = useState("");
  const [isYTInvalid, setIsYTInvalid] = useState<boolean>(false);

  const youtubeCheckLink = () => {
    fetch(
      "https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=xzNT4JywW0A&format=json"
    )
      .then((response) => response.json())
      .then((json) => setDataYT(json))
      .catch((error) => {
        setIsYTInvalid(true);
        console.log("403/404 Video");
      });
  };

  const requestPermission = () => {
    console.log("Requesting Permission.....");
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notificaition Permission Granted");
      } else {
        console.log("Do not have permission");
      }
    });
  };

  const deleteCollaboration = async () => {
    console.log("onlick run " + count);
    await action.deleteCollaborations(count).then((ids) => {
      console.log("finished delete from firebase");
      const elements = ids.map((id) => <div>{id}</div>);
      setDeletedIds(elements);
    });
  };

  const data = [0, 1321, 41512, 2123];

  const find = () => {
    console.log(input);
    const isFound = data.find((value, index, obj) => {
      if (value === input) {
        setResult(<div>found</div>);
        console.log(true);
        return obj;
      }
      console.log(false);
      return undefined;
    });
  };

  const updateCollaborationsToUsertoArraysToUser = () => {
    // Placeholder for collaboration update logic
  };

  const Menu = (props: any) => {
    return (
      <Fragment>
        <components.Menu {...props}>
          <div>
            {props.selectProps.fetchingData ? (
              <span className="fetching">Fetching data...</span>
            ) : (
              <div>{props.children}</div>
            )}
            <button
              className={"change-data"}
              onClick={props.selectProps.changeOptionsData}
            >
              Change data
            </button>
          </div>
        </components.Menu>
      </Fragment>
    );
  };

  return (
    <>
      <div className="fw-bold fs-3 text-gray-400 mb-15" data-testid="faq-page">
        <h2>Playground Page - {process.env.NODE_ENV}</h2>
        <DeviceTest />

        <button
          type="button"
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          Launch demo modal
        </button>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">...</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>

        <input
          name="input"
          type="input"
          onChange={(e) => {
            console.log(e.target.value);
            setInput(e.target.value);
          }}
          value={input}
        />
        <div>
          <Button
            className="btn btn-lg btn-primary fw-bolder"
            onClick={find}
          >
            Find
          </Button>
        </div>
        <div>
          <input
            name="removeNData"
            type="input"
            onChange={(e) => {
              console.log(e.target.value);
              setCount(parseInt(e.target.value));
            }}
          />
        </div>
        <div>
          <Button
            className="btn btn-lg btn-primary fw-bolder"
            onClick={updateCollaborationsToUsertoArraysToUser}
          >
            Update User collaboration to Array User
          </Button>
        </div>
        <div>
          <input
            name="removeCollabs"
            type="input"
            onChange={(e) => {
              console.log(e.target.value);
              setCount(parseInt(e.target.value));
            }}
          />
          <Button
            id="btnDeleteCollabs"
            className="btn btn-lg btn-primary fw-bolder"
            onClick={deleteCollaboration}
          >
            Delete Collaborations
          </Button>
        </div>
      </div>
      <div id="result">
        {deletedIds}
        {result}
      </div>
      <div>
        <div className="App">
          <Select
            defaultValue={selectedOption}
            onChange={setSelectedOption}
            options={options}
            components={{ Menu: Menu }}
          />
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <button
          id="onesignal-popover-allow-button"
          className="align-right primary popover-button"
          onClick={() => youtubeCheckLink()}
        >
          GET YT VALIDATION
        </button>
        <p>HAHAHHA{JSON.stringify(dataYT)}</p>
        <p>{isYTInvalid && "ERROR"}</p>
      </div>
    </>
  );
};

export default SetupCampaignTab;
